/* AOOS landing modules.
   Every module guards on its own host element, so one copy of this file drives whichever
   sections a template includes. Each section emits a deferred tag pointing here; the flag
   below makes the repeats no-ops.
   Data that must not drift from the online customizer (the 18 tube colors, the size ladder,
   the backboard names) deliberately lives HERE rather than in theme settings. Prose is
   editable in the theme editor; product truth is not. */
(function(){
if (window.__aoosModules) return;
window.__aoosModules = 1;
var FILES = 'https://www.aoos.com/cdn/shop/files/';

/* Shopify caches an un-versioned /cdn/shop/files/ URL for a year (max-age=31557600), so
   replacing a file in place with fileUpdate is INVISIBLE on the storefront: the edge keeps
   serving the old bytes. Only the `v` query parameter busts it; unknown params are stripped.
   Bump this whenever an image here is re-uploaded under a filename it already had. */
var IMGV = '?v=1785127085';

/* ---------- knowledge-base link registry ----------
   A landing page cannot explain everything, so every technical module gets a "learn more" hook
   HERE rather than a hardcoded <a> buried in markup. Rules:
     - an EMPTY string renders NO link at all. A module can ship before its article exists and a
       dead link never reaches a customer.
     - only PUBLISHED articles belong here. The 53-article `neon-signs-knowledge-base` blog is an
       unpublished archive; linking into it would 404.
     - on the theme each entry becomes a text setting, so new articles get wired from the theme
       editor without touching code.
   Targets verified published 2026-07-26. */
var LINKS={
  colors:          '/blogs/led-neon-guides/neon-sign-tube-colors-and-how-to-pick',
  gradient:        '/blogs/led-neon-guides/two-color-gradient-neon-signs',
  size:            '/blogs/led-neon-guides/what-size-neon-sign-do-i-need',
  install:         '/blogs/led-neon-guides/how-to-hang-a-neon-sign',
  ulListed:        '/blogs/business-sign-guides/what-ul-listed-means-for-signs',
  backboardShape:  '/pages/backboard-shape-options',
  backboardFinish: '/pages/backboard-color-and-material-options',
  litUnlit:        '/blogs/led-neon-guides/what-a-neon-sign-looks-like-switched-off',
  cost:            '/blogs/led-neon-guides/how-much-does-a-custom-neon-sign-cost',
  warranty:        '/blogs/led-neon-guides/neon-sign-troubleshooting-and-warranty',
  ledVsGlass:      '/blogs/led-neon-guides/is-led-neon-real-neon',
  glassDeepDive:   '/blogs/real-glass-neon-guides/real-glass-neon-vs-led-neon',
  leadTime:        '/blogs/led-neon-guides/how-long-does-a-custom-neon-sign-take'
};
function mountLearn(hostId, items){
  var h=document.getElementById(hostId); if(!h) return;
  h.innerHTML=items.filter(function(it){ return LINKS[it[0]]; })
    .map(function(it){ return '<a class="learn" href="'+LINKS[it[0]]+'">'+it[1]+' →</a>'; })
    .join('');
}

/* ---------- MODULE 1: the authoritative 18-tube palette ---------- */
var TUBES=[
 ["White","#ffffff"],["Warm White","#fffecf"],["Turquoise","#04fffe"],
 ["Ice Blue","#69e1ff"],["Blue","#239aff"],["Deep Blue","#035fff"],
 ["Lemon Yellow","#fffb03"],["Yellow","#ffe217"],["Golden Yellow","#ffcd00"],
 ["Orange","#ffaa1c"],["Tomato","#ff4b00"],["Light Pink","#ff9ae3"],
 ["Hot Pink","#ff40cf"],["Purple","#c904ff"],["Light Purple","#b152ff"],
 ["Red","#ff0000"],["Deep Green","#0ac93c"],["Green","#7dff85"]
];
var tw=document.getElementById('tubes');
TUBES.forEach(function(t){
  var r=document.createElement('div');r.className='tuber';
  r.innerHTML='<span class="tube" style="--c:'+t[1]+'"></span><span class="tname">'+t[0]+'</span>';
  tw.appendChild(r);
});
var r=document.createElement('div');r.className='tuber';
r.innerHTML='<span class="tube rgb"></span><span class="tname">RGB Color Changing'
  +'<i>one color at a time, switched by remote &middot; +50%</i></span>';
tw.appendChild(r);

var g=document.createElement('div');g.className='tuber';
g.innerHTML='<span class="tube grad" style="--a:#ff40cf;--b:#69e1ff"></span>'
  +'<span class="tname">Gradient Color-Changing<i>any two of the 18 colors &middot; quoted, not sold online</i></span>';
tw.appendChild(g);

/* ---------- the two-color picker: any pair of the 18 ----------
   Gradient is enquiry-only: it is NOT a variant, never routes through Add to Cart, and is not
   offered in the online customizer. This block exists to show the option and hand the chosen
   pair to the quote form. When the dedicated gradient product page ships, point GRADIENT_CTA
   at it instead of the on-page quote anchor. */
/* Options we make but do not sell from the buy box all route here. Point this at the
   quote form today; swap it for a dedicated page when one exists. */
var QUOTE_URL='#quote-form';
var GRADIENT_CTA=QUOTE_URL;
var gp={from:12,to:3};   /* Hot Pink -> Ice Blue as the opening pair */
function dots(hostId,key){
  var host=document.getElementById(hostId);
  TUBES.forEach(function(t,i){
    var b=document.createElement('button');
    b.type='button';b.className='gp-dot';b.style.setProperty('--c',t[1]);
    b.title=t[0];b.setAttribute('aria-label',t[0]);
    b.setAttribute('aria-pressed', i===gp[key]?'true':'false');
    b.onclick=function(){
      host.querySelectorAll('.gp-dot').forEach(function(x){x.setAttribute('aria-pressed','false');});
      b.setAttribute('aria-pressed','true');gp[key]=i;paintGradient();
    };
    host.appendChild(b);
  });
}
function paintGradient(){
  var a=TUBES[gp.from],b=TUBES[gp.to];
  var tube=document.getElementById('gpTube');
  if(!tube)return;
  tube.style.setProperty('--a',a[1]);tube.style.setProperty('--b',b[1]);
  var nameEl=document.getElementById('gpName');
  if(nameEl)nameEl.innerHTML=a[0]+' &rarr; '+b[0]
    +'<i>'+(gp.from===gp.to?'pick two different colors to see the blend'
                          :'one of 153 possible pairs')+'</i>';
  /* hand the chosen pair to the quote form so the customer does not retype it.
     The CTA is OPTIONAL: it was removed from the colours module on 2026-07-29 and this line
     threw on null, which killed the rest of this file — module 4 below stopped drawing the
     backboard shapes and finishes entirely. Never dereference an optional node here. */
  var cta=document.getElementById('gpCta');
  if(cta){
    cta.href=GRADIENT_CTA;
    cta.onclick=function(){
      try{sessionStorage.setItem('aoosGradientPair',a[0]+' -> '+b[0]);}catch(e){}
    };
  }
}
dots('gpFrom','from');dots('gpTo','to');paintGradient();


/* ---------- MODULE 4: backboard shape + finish ---------- */
/* Shape names are copied verbatim from the online customizer's Backboard step so the page and
   the buy box never describe the same choice differently. */
var SHAPES=[
 ['cut-to-sign-outline','Cut to Sign Outline','The board follows the outline of the whole design, like a sticker.',1],
 ['cut-to-letter-shape','Cut to Letter Shape','The board hugs each letter, so almost nothing shows but the light.'],
 ['cut-to-rectangle','Cut to Rectangle','Classic rectangular board with rounded corners and corner fixings.'],
 ['no-backboard','No Backboard','Bare tubing on its own mounts. The cleanest look, the most fragile.'],
 ['uv-printed','UV Printed Backboard','Your logo printed in full color on the board itself, or the whole board in one flat color.']
];
var sh=document.getElementById('shapes');
SHAPES.forEach(function(s){
  var art = '<div class="art"><img src="'+FILES+'custom-led-neon-sign-backboard-'+s[0]+'.svg" alt="'
    +s[1]+' backboard for a custom LED neon sign" loading="lazy" decoding="async"'
    +' width="600" height="300"></div>';
  var d=document.createElement('div');d.className='shape';
  if(s[3])d.className+=' is-default';
  d.innerHTML=art+'<b>'+s[1]+(s[3]?'<span class="dflt">Default</span>':'')
    +'<span class="free">No extra cost</span></b><small>'+s[2]+'</small>';
  sh.appendChild(d);
});

var BACKINGS=[
 ['clear-acrylic','Clear Acrylic',1],['black-acrylic','Black Acrylic'],['white-acrylic','White Acrylic'],
 ['silver-mirror','Silver Mirror'],['gold-mirror','Gold Mirror'],['silver-brushed','Silver Brushed'],
 ['gold-brushed','Gold Brushed'],['rose-gold-mirror','Rose Gold Mirror'],['blue-mirror','Blue Mirror'],
 ['red-mirror','Red Mirror'],['green-mirror','Green Mirror'],['purple-mirror','Purple Mirror']
];
var sw=document.getElementById('swatches');
BACKINGS.forEach(function(b){
  var d=document.createElement('div');d.className='sw-card'+(b[2]?' is-default':'');
  d.innerHTML='<img src="'+FILES+'custom-led-neon-sign-backing-'+b[0]+'.webp'+IMGV+'" width="560" height="560"'
    +' loading="lazy" decoding="async" alt="'+b[1]+' backboard for a custom LED neon sign">'
    +'<span>'+b[1]+(b[2]?'<span class="dflt">Default</span>':'')+'</span>';
  sw.appendChild(d);
});

/* ---------- MODULE 2: live size comparison ---------- */
/* Widths and prices mirror the real variants on /products/custom-led-neon-signs.
   Letter counts are pinned to the same anchors used in the Amazon A+ art (20"=5, 36"=10,
   48"=15) so a buyer who sees both is never told two different things. */
var SIZES=[
 {w:20,letters:5, price:"$239.99"},{w:24,letters:6, price:"$287.99"},
 {w:30,letters:8, price:"$359.99"},{w:36,letters:10,price:"$455.99"},
 {w:42,letters:12,price:"$551.99"},{w:48,letters:15,price:"$671.99"},
 {w:54,letters:17,price:"$791.99"},{w:60,letters:19,price:"$935.99"}
];
var PX_PER_IN=276/68;        /* the figure is 5'8" = 68in drawn 276px tall */
var FIG_CX=300, HAND_Y=180;  /* sign sits at hand height */

var chips=document.getElementById('chips');
SIZES.forEach(function(s,i){
  var b=document.createElement('button');
  b.className='chip';b.type='button';b.textContent=s.w+'"';
  b.setAttribute('aria-pressed', i===0?'true':'false');
  b.onclick=function(){
    [].forEach.call(chips.children,function(c){c.setAttribute('aria-pressed','false');});
    b.setAttribute('aria-pressed','true');current=s;draw(s);
  };
  chips.appendChild(b);
});

/* inch ruler down the left edge */
var ticks='',labels='',topY=null,botY=null;
for(var inch=0;inch<=72;inch+=12){
  var y=Math.round(300-inch*PX_PER_IN)+0.5;   /* half-pixel keeps a 1px rule sharp */
  if(topY===null||y<topY)topY=y;
  if(botY===null||y>botY)botY=y;
  ticks+='<line x1="34" y1="'+y+'" x2="40" y2="'+y+'"/>';
  labels+='<text x="30" y="'+(y+3.5)+'" text-anchor="end">'+inch+'"</text>';
}
document.getElementById('rulerTicks').innerHTML=ticks;
document.getElementById('rulerLabels').innerHTML=labels;
/* the axis is drawn from the topmost tick to the bottom one; a hardcoded start left the
   72" mark floating above the line */
var axis=document.getElementById('rulerAxis');
/* Every node lookup below is guarded (2026-07-29). This file drives four modules in
   sequence, so one missing element used to throw and silently kill every module after it —
   deleting one CTA from the colours module stopped the backboard shapes rendering. */
if(axis){
  axis.setAttribute('y1',topY);axis.setAttribute('y2',botY);
}

function draw(s){
  var w=s.w*PX_PER_IN;
  /* a single-line sign is roughly 3.4 : 1, which is what the catalogue photos show */
  var h=Math.max(26,w/3.4);
  var x=FIG_CX-w/2, y=HAND_Y-h/2;
  var p=document.getElementById('signPlate');
  if(p){
    p.setAttribute('x',x);p.setAttribute('y',y);
    p.setAttribute('width',w);p.setAttribute('height',h);
  }
  var t=document.getElementById('signText');
  if(t){
    t.textContent = s.w<=24 ? 'Hello' : (s.w<=36 ? 'Custom Made' : 'Bright Your Space');
    t.setAttribute('x',FIG_CX);t.setAttribute('y',HAND_Y);
  }
  /* Size to the plate height first, then shrink until the wording clears the acrylic edge.
     A fixed cap was what froze the lettering from 48" up and overflowed it at 42". */
  var fs=h*0.66;
  t.setAttribute('font-size',fs);
  var maxW=w*0.86, guard=0, len;
  while((len=t.getComputedTextLength())>maxW && fs>3 && guard++<40){
    fs*=Math.max(0.75, maxW/len);
    t.setAttribute('font-size',fs);
  }
  var d=document.getElementById('dimLine');
  if(d){
    d.setAttribute('x1',x);d.setAttribute('x2',x+w);
    d.setAttribute('y1',y-12);d.setAttribute('y2',y-12);
  }
  var dl=document.getElementById('dimLabel');
  if(dl){
    dl.setAttribute('x',FIG_CX);dl.setAttribute('y',y-18);
    dl.textContent=s.w+'" wide';
  }

  document.getElementById('roW').innerHTML=s.w+'&Prime; wide';
  document.getElementById('roH').innerHTML='approx. '+Math.round(s.w/3.4)+'&Prime; tall';
  document.getElementById('roL').textContent='~'+s.letters+' letters on one line';
  document.getElementById('roP').textContent=s.price;
}
var current=SIZES[0];
draw(current);
/* the script face changes every measurement, so re-fit once it has actually loaded */
if(document.fonts&&document.fonts.ready){document.fonts.ready.then(function(){draw(current);});}
/* ---------- MODULE 5: lit / unlit ----------
   Needs a MATCHED PAIR: same sign, same camera position, same framing, one powered and one not.
   Until both exist the module renders a dev placeholder here and NOTHING on the live page --
   a half-filled comparison is worse than no comparison. */
/* ---------- MODULE 5 data: one entry per backboard we have an on/off pair for ----------
   A pair needs BOTH photos: same sign, same camera position, same framing, same manual exposure,
   only the switch changes. An entry with either photo missing is skipped entirely -- a half-filled
   comparison is worse than none.
   ORDER MATTERS: clear acrylic is the default and what most orders ship with, so it leads. The
   mirror entry is the contrast ("if you want it to still read as an object when off"), never the
   headline -- leading with it would use a minority finish to represent everyone.
   With 2+ complete pairs the module renders chips to switch between boards; with 1 it just shows
   that comparison and no chips. */
var LIT_PAIRS=[
  { board:'Clear Acrylic',
    note:'The default board. Switched off the acrylic barely reads, and you are left with the tubing.',
    on:FILES+'custom-led-neon-sign-clear-backboard-lit-warm-white-glow.webp',
    off:FILES+'custom-led-neon-sign-clear-backboard-unlit-frosted-tubing.webp' },
  { board:'Gold Mirror',
    note:'A mirror board is still a mirror when the sign is off, so it stays an object on the wall.',
    on:FILES+'custom-led-neon-sign-gold-mirror-backboard-lit-rgb.webp',
    off:FILES+'custom-led-neon-sign-gold-mirror-backboard-unlit-frosted-tubing.webp' }
];

(function(){
  var host=document.getElementById('litUnlit'); if(!host) return;
  var ready=LIT_PAIRS.filter(function(p){ return p.on && p.off; });

  if(!ready.length){
    host.innerHTML=LIT_PAIRS.map(function(p){
      return '<div class="todo">Awaiting art: '+p.board+'<br>lit + unlit, same camera position and settings</div>';
    }).join('');
    host.className='lu todoGrid';
    return;
  }

  var chips=document.getElementById('luChips');
  function paint(p){
    host.innerHTML=
      '<figure><img src="'+p.on+'" width="1200" height="800" loading="lazy" decoding="async"'
        +' alt="Custom LED neon sign on a '+p.board+' backboard, switched on">'
        +'<figcaption>Switched on<small>The color you picked, at full brightness or dimmed.</small></figcaption></figure>'
     +'<figure><img src="'+p.off+'" width="1200" height="800" loading="lazy" decoding="async"'
        +' alt="The same custom LED neon sign on a '+p.board+' backboard, switched off">'
        +'<figcaption>Switched off<small>'+p.note+'</small></figcaption></figure>';
  }
  if(ready.length>1 && chips){
    ready.forEach(function(p,i){
      var b=document.createElement('button');
      b.type='button'; b.className='chip'; b.textContent=p.board;
      b.setAttribute('aria-pressed', i===0?'true':'false');
      b.onclick=function(){
        [].forEach.call(chips.children,function(x){x.setAttribute('aria-pressed','false');});
        b.setAttribute('aria-pressed','true'); paint(p);
      };
      chips.appendChild(b);
    });
  }
  paint(ready[0]);
})();

(function(){var c=document.getElementById('tubeCta'); if(c) c.href=QUOTE_URL;})();

mountLearn('learnColors',    [['colors','How neon tube colors are made'],['gradient','About two-color gradients']]);
mountLearn('learnSize',      [['size','What size neon sign do I need?']]);
mountLearn('learnBackboard', [['backboardShape','Backboard shapes explained'],['backboardFinish','Backboard colors and materials']]);
mountLearn('learnBox',       [['install','How to hang a neon sign'],['ulListed','What UL listed actually means']]);
mountLearn('learnLit',       [['litUnlit','What the tubes look like on and off']]);
mountLearn('learnTimeline',  [['leadTime','How long a custom sign takes'],['cost','What a custom neon sign costs']]);
mountLearn('learnWarranty',  [['warranty','Troubleshooting and warranty']]);
mountLearn('learnDirect',    [['cost','How custom neon is priced']]);
mountLearn('learnGlass',     [['ledVsGlass','Is an LED neon sign real neon?'],['glassDeepDive','Real glass neon vs LED neon']]);


})();
